import styled from '@emotion/styled';

export const Container = styled.div`
  display: grid;
  gap: 16px;
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
`;
